module.exports = __webpack_public_path__ + "87f8ff6511b6c12e826fa90313ea9733.pdf";